import { defineMessages } from 'react-intl-next';
export var searchInputMessages = defineMessages({
  placeholder: {
    id: 'linkDataSource.assets.configModal.aqlSearchInput.placeholder',
    description: 'Display text for AQL search button',
    defaultMessage: 'Search via AQL'
  },
  helpTooltipText: {
    id: 'linkDataSource.assets.configModal.aqlSearchInput.helpTooltipText',
    description: 'Link to AQL Syntax help document',
    defaultMessage: 'Syntax help'
  }
});